export function downloadFile (dataByte, fileName) {
  let blob = new Blob([dataByte], { type: 'application/octet-stream' });
  if (navigator.msSaveBlob)
    navigator.msSaveBlob(blob, fileName);
  else {
    // Try using other saveBlob implementations, if available
    // let saveBlob = saveAs || saveBlob.saveAs || navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
    // if(saveBlob === undefined) throw "Not supported";
    var a = document.createElement("a");
    document.body.appendChild(a);
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}